export const ROUTES = {
  // Home
  HOME: '/',

  // Auth management
  AUTH: 'auth',
  AUTH_FORGOT_PASSWORD: 'forgot-password',
  AUTH_LOGIN: 'login',
  AUTH_RESET_PASSWORD: 'reset-password',
  AUTH_SIGNUP: 'signup',
  AUTH_USER_VERIFICATION: 'verification',
  AUTH_VERIFY_EMAIL: 'verify-email',

  VERIFICATION: 'auth/verification',
  VERIFICATION_REQUEST: 'request',
  VERIFICATION_CONFIRM: '',

  // Organization Slug
  ORG_SLUG: ':orgSlug',

  // Dashboard
  DASHBOARD: 'dashboard',
  DASHBOARD_BUILDING: ':buildingId',

  // Buildings management
  BUILDINGS: 'buildings',
  BUILDING_CREATE: 'buildings/new',
  BUILDING_DETAILS: 'buildings/:buildingId',

  // Zones management
  ZONES: 'zones',
  ZONES_ACTIVE: 'active',
  ZONES_INACTIVE: 'inactive',
  ZONE_CLEANING_HISTORY: 'zones/:zoneId/cleaning-history',

  // Service interruptions
  SERVICE_INTERRUPTIONS: 'service-interruptions',

  // Feedback
  FEEDBACK: 'feedback',

  // Reporting
  REPORTS: 'reports',
  PDF_VIEW: 'pdf-view', // For only local development

  // Team
  TEAM: 'team',

  // Employees
  EMPLOYEES: 'employees',

  // Profile pages
  PROFILE: 'profile',
  PROFILE_BILLING: 'billing',
  PROFILE_INVITE_USERS: 'invite-users',
  PROFILE_NOTIFICATIONS: 'notifications',
  PROFILE_PASSWORD: 'password',
  PROFILE_USER_SETTINGS: 'user-settings',
  COMPANY_SETTINGS: 'company-settings',
  ZONE_CATEGORIES: 'zone-categories',

  // Order decals
  ORDER_DECALS: 'order-decals',

  // Cart
  CART: 'cart',
  REVIEW_CART: 'cart/review',

  // Supervisor
  // Note: No need to log in to access to the pages
  SUPERVISOR: 'supervisor',
  SUSPEND_SERVICE: 'suspend-service/zone/:zoneId', // e.g http://localhost:3000/supervisor/suspend-service/zone/{zoneId}?org={orgSlug}&schedule={scheduleId}&user={userId}
  SUSPEND_SERVICE_SUCCESS: 'suspend-service/success',

  // Public zone page
  CODE: 'code',
  CODE_PAGE: ':code',
  CODE_EMPLOYEE_ACCESS: ':code/employee-access',
};
